export default {"src":"/_next/static/media/curved-dotted-line.65e9699a.svg","height":48,"width":875,"blurWidth":0,"blurHeight":0};